import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

import { useIsTeamsHub } from './selectors';
import { useIsVivaEngageEntity } from './useIsVivaEngageEntity';

type UseIsVivaEngageApp = (shouldCheckVivaEngageEntityInTeams?: boolean) => boolean;
export const useIsVivaEngageApp: UseIsVivaEngageApp = (shouldCheckVivaEngageEntityInTeams = true) => {
  const isVivaEngageInTeamsEnabled = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAppUXMC) === 'control';
  const isVivaEngageInMetaOsEnabled = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAppInMetaOs) === true;
  const isVivaEngageEntity = useIsVivaEngageEntity();
  const isTeamsHub = useIsTeamsHub();
  const shouldEmulateVivaEngage = (process.env.EMULATE_VIVA_ENGAGE as unknown) === true;

  if (shouldEmulateVivaEngage) {
    return true;
  }

  if (isTeamsHub) {
    if (!shouldCheckVivaEngageEntityInTeams) {
      return isVivaEngageInTeamsEnabled;
    }

    return isVivaEngageEntity && isVivaEngageInTeamsEnabled;
  }

  return isVivaEngageEntity && isVivaEngageInMetaOsEnabled;
};
